export const DEFAULT_PAGINATION_PAGE = 1;
export const DEFAULT_PAGINATION_PAGE_SIZE = 10;
export const PAGINATION_PAGE_PARAM = 'page';
export const PAGINATION_PAGE_SIZE_PARAM = 'pageSize';
